import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-dark-card border-t border-dark-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Brand Section - Full Width */}
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-4">
            <img 
              src="https://avatars.githubusercontent.com/in/1201222?s=120&u=2686cf91179bbafbc7a71bfbc43004cf9ae1acea&v=4" 
              alt="Emergent Showcase"
              className="w-8 h-8 rounded-full"
            />
            <span className="text-lg font-bold text-white">Emergent Showcase</span>
          </div>
          <p className="text-sm text-gray-400">
            Discover amazing apps built with Emergent.sh
          </p>
        </div>

        {/* Product, Resources, Community - Side by Side */}
        <div className="grid grid-cols-3 gap-12 mb-8">
          {/* Product */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-brand-yellow transition-colors">
                  Browse Apps
                </Link>
              </li>
              <li>
                <Link to="/submit" className="text-sm text-gray-400 hover:text-brand-yellow transition-colors">
                  Submit App
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-brand-yellow transition-colors">
                  Emergent.sh
                </a>
              </li>
              <li>
                <a href="https://docs.emergent.sh" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-brand-yellow transition-colors">
                  Documentation
                </a>
              </li>
              <li>
                <a href="https://vibes.emergent.sh/blogs" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-brand-yellow transition-colors">
                  Learn Vibe Coding
                </a>
              </li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">Community</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://x.com/EmergentLabsHQ" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-brand-yellow transition-colors">
                  X
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/emergentlabs/?hl=en" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-brand-yellow transition-colors">
                  Instagram
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/emergentlabs" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-brand-yellow transition-colors">
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-dark-border">
          <p className="text-sm text-gray-500 text-center">
            © {new Date().getFullYear()} Emergent Spotlight. Built with ❤️ using Emergent.sh
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
